<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="size"
       :height="size"
       :fill="fill"
       viewBox="-1 -1 34 34"
       xml:space="preserve">
      <path d="M21,8H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"/>
      <path d="M21,12H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"/>
      <path d="M21,16H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"/>
      <path d="M21,20H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"/>
      <path d="M7,16H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z"/>
      <path d="M7,20H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z"/>
      <path d="M27,16H25a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"/>
      <path d="M27,20H25a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"/>
      <path d="M12,30H7a1,1,0,0,1-1-1V5A3,3,0,0,1,9,2H23a3,3,0,0,1,3,3V7a1,1,0,0,1-2,0V5a1,1,0,0,0-1-1H9A1,1,0,0,0,8,5V28h4a1,1,0,0,1,0,2Z"/>
      <path d="M25,30H16a1,1,0,0,1,0-2h8V14a1,1,0,0,1,2,0V29A1,1,0,0,1,25,30Z"/>
      <path d="M7,30H1a1,1,0,0,1-1-1V13a3,3,0,0,1,3-3H7a1,1,0,0,1,1,1V29A1,1,0,0,1,7,30ZM2,28H6V12H3a1,1,0,0,0-1,1Z"/>
      <path d="M31,30H25a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1h4a3,3,0,0,1,3,3V29A1,1,0,0,1,31,30Zm-5-2h4V13a1,1,0,0,0-1-1H26Z"/>
      <path d="M20,30a1,1,0,0,1-1-1V24H13v5a1,1,0,0,1-2,0V24a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2v5A1,1,0,0,1,20,30Z"/>
  </svg>
</template>

<script>
export default {
  name: "LoaderIcon",
  props: {
    size: {
      type: Number,
      default: 64
    },
    fill: {
      type: String,
      default: 'currentColor'
    },
  }
}
</script>
